<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Case Managment" bc1="App" bc2="Manage Cases"></Breadcrumb>
        </div>
        <div class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none">
        </div>
      </div>
      <div class="content-body">

        <section id="page-account-settings">
          <div class="row">
            <!-- left menu section -->
            <div class="col-md-3 mb-2 mb-md-0">
              <ul class="nav nav-pills flex-column nav-left">

                <li class="nav-item" @click="currentTab = 1">
                  <a class="nav-link active" id="account-pill-general" data-toggle="pill"
                     href="#account-vertical-general" aria-expanded="true">

                    <feather type="layers" class="font-medium-3 mr-1 font-weight-bolder"></feather>
                    <span class="font-weight-bold">Department</span>
                  </a>
                </li>
                <li class="nav-item" @click="currentTab = 2">
                  <a class="nav-link " id="account-pill-case-type" data-toggle="pill"
                     href="#account-vertical-case-type" aria-expanded="true">

                    <feather type="layers" class="font-medium-3 mr-1 font-weight-bolder"></feather>
                    <span class="font-weight-bold">Case Type</span>
                  </a>
                </li>
                <li class="nav-item" @click="currentTab = 3">
                  <a class="nav-link " id="account-pill-case" data-toggle="pill"
                     href="#account-vertical-case" aria-expanded="true">

                    <feather type="layers" class="font-medium-3 mr-1 font-weight-bolder"></feather>
                    <span class="font-weight-bold">Case Managment</span>
                  </a>
                </li>
              </ul>
            </div>
            <!--/ left menu section -->

            <!-- right content section -->
            <div class="col-md-9">
              <div class="card">
                <div class="card-body">
                  <div class="tab-content">


                    <div v-if="!showSubDepart" role="tabpanel" class="tab-pane active"
                         id="account-vertical-general" aria-labelledby="account-pill-general"
                         aria-expanded="true">
                      <DepartmentTab v-if="currentTab == 1"  />
                    </div>

                  <div role="tabpanel" class="tab-pane" id="account-vertical-case-type"
                       aria-labelledby="account-pill-case-type" aria-expanded="true">

                    <CaseTypeTab v-if="currentTab == 2" />
                  </div>

                  <div role="tabpanel" class="tab-pane fade" id="account-vertical-case"
                       aria-labelledby="account-pill-case" aria-expanded="true">

                    <CaseMTab v-if="currentTab == 3" />
                  </div>

                </div>
              </div>
            </div>
          </div>

          <!--/ right content section -->
      </div>
      </section>


    </div>
  </div>


  </div>
</template>

<script>
import DepartmentUpdateModal from "./DepartmentUpdateModal.vue"
import DepartmentCreateModal from "./DepartmentCreateModal.vue"
import DepartmentAssignStaff from "./DepartmentAssignStaff.vue"
import CreateCaseModal from "./CreateCaseModal.vue"
import CaseActionModal from "./CaseActionModal.vue"
import CaseUpdateStatusModal from "./CaseUpdateStatusModal.vue"
import CaseLogsModal from "./CaseLogsModal.vue"
import DepartmentAssignSubDepart from "./DepartmentAssignSubDepart.vue"
import CaseTypeCreateModal from "./CaseTypeCreateModal.vue"
import CaseTypeTab from "./tabs/case-type/CaseTypeTab.vue";
import DepartmentTab from "./tabs/department/DepartmentTab.vue";
import CaseMTab from "./tabs/case-m/CaseMTab.vue";

export default {
  components: {
    DepartmentTab,
    CaseTypeTab,
    DepartmentUpdateModal,
    DepartmentAssignStaff,
    DepartmentCreateModal,
    CreateCaseModal,
    CaseActionModal,
    CaseUpdateStatusModal,
    CaseLogsModal,
    DepartmentAssignSubDepart,
    CaseTypeCreateModal,
    CaseMTab
  },
  mounted() {
    // this.getMerchantData()
  },
  data() {
    return {
      currentTab: 1,
      showUpdateModel: false,
      showCreateModel: false,
      showCreateCaseModel: false,
      showUpdateCaseModel: false,
      showAssignStaffModel: false,
      ShowCaseActionModal: false,
      ShowCaseUpdateModal: false,
      ShowCaseLogsModal: false,
      ShowAssignSubDepartModal: false,
      showCreateCaseTypeModel: false,
      showSubDepart: false,
      MerchantsData: [],
    }
  },
  methods: {
    getMerchantData() {
      this.makeRequest("post", "v1/get-merchants", {flag: 'all'}, {}, false, true, [205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.MerchantsData = responseData;
              }
            }
          }
      );
    },
  }
}
</script>
  
  
  
  